<template>
  <div id="municipalInfoDetail" data-role="page">
    <!-- content -->
    <div class="municipalInfoDetail-content" data-position="fixed">
      <!-- 未連接至網路的提醒 -->
      <div v-if="!closeOffline && isOffline" class="v3offline">
        <i class="icon-exclamation-mark-circle"></i>
        <p>未連接至網路</p>
        <div @click="closeOfflineHandle"><i class="icon-close"></i></div>
      </div>
      <div class="detailWrap" v-if="detailData.Id">
        <div class="detail-h">
          <h3 :class="{ LargSize: fz_larg }">{{ detailData.Title }}</h3>
          <span
            class="article_date"
            :class="{ LargSize: fz_larg }"
          >
            <template v-if="detailData.StartAt">
                {{ filterDate(detailData.StartAt, detailType) }}
            </template>
            <template v-if="detailData.CreateAt">
                {{ filterDate(detailData.CreateAt, detailType) }}
            </template>
          </span>
        </div>
        <!-- 文章內容 -->
        <div class="detail-c">
          <div class="txtContent" :class="{ LargSize: fz_larg }">
            <p v-if="detailType === '1' && detailData.ResourceAgency">發佈單位: {{ detailData.ResourceAgency }}</p>
            <div v-if="detailType === '2'">
                <p v-if="detailData.Date">活動日期: {{ filterDate(detailData.Date, detailType) }}</p>
                <p v-if="detailData.DueDate">活動迄日: {{ filterDate(detailData.DueDate, detailType) }}</p>
                <p v-if="detailData.ActivitiesClass">類別: {{ detailData.ActivitiesClass }}</p>
                <p v-if="detailData.ResourceAgency">來源機關: {{ detailData.ResourceAgency }}</p>
            </div>
            <p v-if="detailType === '2'">內容: </p>
            <p v-html="contentTransform(detailData.Content)"></p>
            <div v-if="detailType === '2'">
                <p v-if="detailData.IsNeedSignUp">是否報名: {{ detailData.IsNeedSignUp }}</p>
                <p v-if="detailData.IsNeedPay">是否付費: {{ detailData.IsNeedPay }}</p>
                <p v-if="detailData.Fee">費用: {{ detailData.Fee }}</p>
                <p v-if="detailData.Location">活動場地: {{ detailData.Location }}</p>
                <p v-if="detailData.LocationPhone">場地電話: {{ detailData.locationPhone }}</p>
                <p v-if="detailData.LocationAddress">活動地址: {{ detailData.LocationAddress }}</p>
                <p v-if="detailData.Traffic">交通說明: <span v-html="contentTransform(detailData.Traffic)"></span></p>
                <p v-if="detailData.ContactPerson" class="people">聯絡人: {{ detailData.ContactPerson }}</p>
                <p v-if="detailData.ContactPhone">聯絡電話: {{ detailData.ContactPhone }}</p>
                <p v-if="detailData.ContactEmail">電子信箱: {{ detailData.ContactEmail }}</p>
                <p v-if="detailData.isAboutUrl">活動網址: <span v-html="contentTransform(detailData.AboutUrl)"></span></p>
            </div>
          </div>
        </div>
        <!-- /文章內容 -->
        <!-- 附檔 -->
        <!-- <div class="detail-a" v-if="detailData.file && detailData.file.length">
          <div class="attachTitle">檢視附加檔案</div>
          <div class="attachFileWrap" :class="{'LargSize':fz_larg}">
            <div v-for="(file, fileIdx) in detailData.file" :key="fileIdx" class="attachFile" @click="OpenFile(file.url)">
              <i class="icon-clip"></i>
              <span>{{ file.name }}</span>
            </div>
          </div>
        </div> -->
        <!-- /附檔 -->
      </div>
      <div class="loading-wrap" v-else>
        <p class="loading-rotate"></p>
      </div>
    </div>
    <div id="v3functionBar" class="qk-functionBar active" v-if="Authority && detailData.Id">
      <div :class="['qk-functionBar-wrap-col4']">
        <div
          class="fontsize-option"
          v-on:click="ChangeSize"
          :class="{ active: fz_larg }"
        >
          <span><i class="icon-font-size"></i>大小</span>
        </div>
        <div class="share-option" @click="Share">
          <span><i class="icon-export"></i>分享</span>
        </div>
      </div>
    </div>
    <!-- /footer -->
    <div v-show="v3Toast.show" class="v3Toast">{{ v3Toast.text }}</div>
  </div>
</template>

<script lang="js">
export default {
    data () {
        return {
            detailData: {},
            Authority: false,   
            fz_larg: false,
             v3Toast:{
                show: false,
                text: '',
                duration: 1000
            },
            detailId:this.$route.params.id,
            detailType:this.$route.params.type,
            detailIndex:this.$route.params.idx,
            closeOffline:false,
            tempPage: 0,
            canOpen: true
        }
    },
    watch: {
        isOffline: function(val) {
            // 在下次無網路時再度打開上面的 top tip
            if (!val) this.closeOffline = false
        }
    },
    mounted(){
        this.getDetail(this.detailIndex)
        this.CheckAuthority()
    },
    methods:{
        async getDetail (index) {
            const vm = this
            let page = Math.floor(index / 50)
            let url = ''
            let resListName = ''
            const params = {
                Page: page,
                Size: 50
            }
            switch (this.detailType) {
                case '1':
                    url = `${process.env.SmartlifeCoreApi}/v3.14/NewTaipeiOpenApi/CityNews`
                    resListName = 'CityNews'
                    break;
                case '2':
                    url = `${process.env.SmartlifeCoreApi}/v3.14/NewTaipeiOpenApi/RecentActivities`
                    resListName = 'CurrentActivities'
                    break;
                case '3':
                    url = `${process.env.SmartlifeCoreApi}/v3.14/NewTaipeiOpenApi/HotNews`
                    resListName = 'HotNews'
                    break;  
                default:
                    break;
            }
            // 從傳入的 index 推算頁數，一次取 50 筆資料，如果沒有找到該筆資料，則從第 0 頁開始找。
            await this.axios.get(url, {params}).then((response) => {
                const detail = response.data.Data[resListName].find(item => {
                    return item.Id === this.detailId
                })
                if (!detail) {
                    if (response.data.Data[resListName].length && this.tempPage < 5) {
                        this.getDetail(this.tempPage * 50, 50)
                        this.tempPage ++
                    } else {
                        this.showV3Toast('查無此新聞內容')
                        setTimeout(() => {
                            vm.$router.back()
                        }, this.v3Toast.duration);    
                    }                            
                } else {
                    this.detailData = detail
                    this.detailData.file = []
                    this.detailData.isAboutUrl = false
                    this.tempPage = 0
                    const dataDom = document.createElement('div')
                    dataDom.innerHTML = this.detailData.downloadUrl
                    dataDom.childNodes.forEach((item, index) => {
                        if (!(index % 2) && item.innerText !== '.') {
                            this.detailData.file.push({
                                name: item.innerText,
                                url: item.href
                            })                        
                        }
                    })
                    dataDom.innerHTML = this.detailData.picUrl
                    dataDom.childNodes.forEach((item, index) => {
                        if (item.innerText !== '.') {
                            this.detailData.file.push({
                                name: item.innerText,
                                url: item.href
                            })
                        }
                    })
                    dataDom.innerHTML = this.detailData.aboutUrl
                    console.dir(dataDom)
                    dataDom.childNodes.forEach((item, index) => {
                        if (item.innerText && item.innerText !== '.') {
                            this.detailData.isAboutUrl = true
                        }
                    })
                }             
            }).catch((err) => {
                console.log(err)
            })
        },
        //檢查權限
        CheckAuthority(){
            if(localStorage.getItem("v3token")=='' || localStorage.getItem("v3token") == null){
                this.Authority= false
            }else{
                this.Authority= true
            }
        },
        contentTransform(content){
            let returnObj = content
            if(returnObj){
                return returnObj.replace(/\n/g,'<br>').replace(/&lt;br&gt;/g, '<br>')
            }else{
                return returnObj
            }
            
        },
        //打開檔案
        OpenFile(link){
            if (this.Authority) {
                window.open(`https://inapp.kingnetsmart.com.tw/ad.html?page=linkRule&params1=7&params2=${encodeURIComponent(link)}&title=${encodeURIComponent(this.detailData.title)}&referrer=${encodeURIComponent(location.href)}`,'_blank')
            } else {
                window.open(link)
            }
        },
        //文字大小變化
        ChangeSize(){
            this.fz_larg ? this.fz_larg=false : this.fz_larg=true;
        },
        //分享按鈕     
        Share(){
            const vm = this
            if (!vm.canOpen) {
                return false
            } else {
                vm.canOpen = false
                document.location.replace(`/#/newMunicipalInfoDetail/${this.detailType}/${this.detailId}/${this.detailIndex}/?KNSTMethod=share&title=${encodeURIComponent(this.detailData.Title)}&type=municipal`)
                // 防止連點
                setTimeout(() => {
                    vm.canOpen = true
                }, 1000)
            }
        },
        closeOfflineHandle(){
            this.closeOffline = true
        },
        showV3Toast(text) {
            clearTimeout(this.toastTimer)
            this.v3Toast.text = text;
            this.v3Toast.show = true;
            this.toastTimer = setTimeout(() => {
                this.v3Toast.show = false;
            }, this.v3Toast.duration);
        },
        filterDate(date, tab) {
            const splitDate = date.split('/')
            switch(tab) {
              case '1':
                return date.split('T')[0]
              case '2':
              case '3':
                return `${splitDate[2]}/${splitDate[0]}/${splitDate[1]}`
            }
        }
    },
}
</script>
<style lang="css" scoped>
.v3Toast {
  position: fixed;
  left: 50%;
  top: 50%;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  line-height: 27px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  background: rgba(0, 0, 0, 0.7); /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  padding: 7px 10px 6px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  color: #fff;
  font-size: 15px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  font-weight: 500;
}
.v3offline {
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 44px;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 21px;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  color: #fff;
  background: rgba(
    66,
    137,
    167,
    0.9
  ); /* #4289a7 2020/11/19 13:37 BD mean this color */
  -webkit-transition: 0.5s;
  transition: 0.5s;
}
.v3offline > i {
  margin-right: 9px;
  font-size: 19px;
  width: 19px;
  height: 19px;
}
.v3offline div {
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.municipalInfoDetail-content {
    -webkit-user-select:none;
    -moz-user-select:none;
    -o-user-select:none;
    user-select:none;
}
.detailWrap {
    padding-bottom: calc(66px + constant(safe-area-inset-bottom));
    padding-bottom: calc(66px + env(safe-area-inset-bottom));
}
.detail-c .txtContent p {
  word-break: break-word;
}
.detail-c .txtContent .people {
  margin-top: 32px;
}
.loading-wrap {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* v3functionBar */

#v3functionBar.active {
  background: transparent;
  opacity: 1;
  bottom: 24px;
  -webkit-user-select:none;
  -moz-user-select:none;
  -o-user-select:none;
  user-select:none;
}

#v3functionBar [class|="qk-functionBar-wrap"] {
  width: auto;
  margin: 0 8px;
  padding: 0 8px;
  border-radius: 23px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

#v3functionBar [class|="qk-functionBar-wrap"] div {
  background: transparent;
}
#v3functionBar [class|="qk-functionBar-wrap"] span {
  font-size: 13px;
  color: #484848;
}

#v3functionBar [class|="qk-functionBar-wrap"] div.active i {
  color: #46b39a;
}

#v3functionBar [class|="qk-functionBar-wrap"] div.active span {
  color: #46b39a;
}
#v3functionBar .fontsize-option {
  float: left;
  width: 50%;
}
#v3functionBar .share-option {
  float: none;
  width: 50%;
}

</style>


// WEBPACK FOOTER //
// src/components/v3/newMunicipal/municipalInfoDetail.vue